import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchKpiDataForDates = async (user, selectedDate, comparedDate) => {
  try {
    const [selectedData, comparedData] = await Promise.all([
      fetchKpiDataForDate(user, selectedDate),
      fetchKpiDataForDate(user, comparedDate),
    ]);
    console.log({ selectedData, comparedData })
    return { selectedData, comparedData };
  } catch (error) {
    console.error("Error fetching KPI data for dates:", error);
    return {
      selectedData: getDefaultKpiData(),
      comparedData: getDefaultKpiData(),
    };
  }
};

const getDefaultKpiData = () => ({
  gains: 0,
  avg_trade_per_client: 0,
  unique_clients: 0,
  clients_profit_loss: 0,
  volumes: [],
  trades_count: 0,
  deposits: 0
});

export const fetchKpiDataForDate = async (user, date) => {
  try {
    if (date.startDate === null || date.endDate === null) {
      return getDefaultKpiData();
    }

    const params = `?startDate=${date.startDate}&endDate=${date.endDate}`

    const { data } = await axios.get(`${API_BASE_URL}/agbk/kpis${params}`, buildHeaders(user));

    console.log('data', data)
    return data?.data;

  } catch (error) {
    console.error("Error fetching AGO KPI data:", error);
    return getDefaultKpiData();
  }
};